<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="characters">
<h1>Characters</h1>
<p style="text-indent:0em !important;">Lord Armando</p>
<p style="text-indent:0em !important;">Sister Helewise</p>
<p style="text-indent:0em !important;">Duke of Landburg</p>
<p style="text-indent:0em !important;">Duchess Bella</p>
<p style="text-indent:0em !important;">Roseabella: Oldest daughter</p>
<p style="text-indent:0em !important;">Eder: Son of Duke and Duchess</p>
<p style="text-indent:0em !important;">Ardelean: Middle daughter of Duke and Duchess</p>
<p style="text-indent:0em !important;">Gretta: Youngest daughter of Duke and Duchess</p>
<p style="text-indent:0em !important;">Josiah: Son of Roseabella and Armando</p>
<p style="text-indent:0em !important;">Soneia and Armanda: twin daughters of Roseabella and Armando</p>
<p style="text-indent:0em !important;">Gerrold: Armando’s top man</p>
<p style="text-indent:0em !important;">Meiga: Wife of Gerrold</p>
<p style="text-indent:0em !important;">Saige: Granddaughter of Gerrold and Meiga</p>
<p style="text-indent:0em !important;">Father Strickland: Priest</p>
<p style="text-indent:0em !important;">Marga and Ragga: Twin slayers</p>
<p style="text-indent:0em !important;">Romane: Ship crew</p>
<p style="text-indent:0em !important;">Captain Morgan: Captain of the ship (who is in love with Helewise)</p>
<p style="text-indent:0em !important;">2 puppies bought in a port for supply run, on Armando’s ship, they grow huge and are trained as fighting dogs.</p>
<p style="text-indent:0em !important;">Garrett: Cousin of Armando and Helewise who turns Vampire.</p>
<p style="text-indent:0em !important;">Morgania: Vampire woman</p>
<p style="text-indent:0em !important;">Hatmanu: Slave to the Vampires</p>
<p style="text-indent:0em !important;">Rueband: Boy on Garrett’s ship</p>
<p style="text-indent:0em !important;">Bacia: Garrett’s top man</p>
<p style="text-indent:0em !important;">Manu: was whipped and fed to the sharks for attacking Rueband and Gretta</p>
<p style="text-indent:0em !important;">Dr. Bardue: Doctor on Garrett’s ship</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?54ec70a2